// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { subWeeks as fn } from "../subWeeks.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const subWeeks = convertToFP(fn, 2);

// Fallback for modularized imports:
export default subWeeks;
